import { render, staticRenderFns } from "./TableRowRns.vue?vue&type=template&id=31e79b54"
import script from "./TableRowRns.vue?vue&type=script&lang=js"
export * from "./TableRowRns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports